import React from 'react';

/* ═══════ LUMINEX BRAND MARK ═══════
   Diamond (rotated square) with 4 cardinal tick marks and an ember dot.
   Stroke color follows currentColor so it inherits from parent (Steel Blue on light,
   Steel 300 on dark). The center dot is always Construction Orange (#F26B1F — brand spark).

   The file & exports keep their legacy "Luminex" names so existing call-sites
   continue to work — only the rendered content has been refreshed. */

export const LuminexIcon = ({ size = 28, className = '', style = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 56 56"
    width={size}
    height={size}
    className={className}
    style={style}
    aria-hidden="true"
    data-testid="luminex-icon"
  >
    <rect
      x="12" y="12" width="32" height="32" rx="3"
      fill="none" stroke="currentColor" strokeWidth="2"
      transform="rotate(45 28 28)"
    />
    <line x1="28" y1="0"  x2="28" y2="10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="28" y1="46" x2="28" y2="56" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="0"  y1="28" x2="10" y2="28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="46" y1="28" x2="56" y2="28" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="28" cy="28" r="4" fill="#F26B1F" />
  </svg>
);

/* Full lockup — icon + "Luminex" wordmark in Playfair Display italic.
   The trailing letter is rendered in ember to echo the center dot. */
export const LuminexLockup = ({ iconSize = 30, onClick }) => (
  <span
    data-testid="luminex-lockup"
    onClick={onClick}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 12,
      cursor: onClick ? 'pointer' : 'default',
      userSelect: 'none',
      color: 'var(--accent)', // stroke color for the icon
    }}
  >
    <LuminexIcon size={iconSize} />
    <span style={{
      fontFamily: '"Playfair Display", Georgia, serif',
      fontStyle: 'italic',
      fontSize: 22,
      fontWeight: 400,
      color: 'var(--text-1)',
      letterSpacing: '-0.02em',
      lineHeight: 1,
    }}>
      Lumine<span style={{ color: '#F26B1F' }}>x</span>
    </span>
  </span>
);

/* All call-sites have been migrated to LuminexIcon / LuminexLockup; default
   export remains the lockup. */

export default LuminexLockup;
